import React, { forwardRef } from 'react'
import { useMobStyles } from './pageContainer.styles'
import { Container, Divider } from '@material-ui/core'
import { PageHeaderMob } from 'components/PageHeader'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const PageContainerMobile = forwardRef((props, ref) => {
  const {
    className,
    headerProps = {},
    disablePaddings = false,
    customHeader,
    ...other
  } = props
  const classes = useMobStyles()
  return (
    <Container
      maxWidth={'sm'}
      className={clsx(!disablePaddings && classes.root, className)}
      ref={ref}
      {...other}
    >
      <div>{React.isValidElement(customHeader) ? customHeader : <></>}</div>
      <>{props.children}</>
    </Container>
  )
})
export default PageContainerMobile
PageContainerMobile.propTypes = {
  headerProps: PropTypes.object,
  customHeader: PropTypes.node
}
